import { render } from "./ProfileUpdate.vue?vue&type=template&id=0a007006"
import script from "./ProfileUpdate.vue?vue&type=script&lang=js"
export * from "./ProfileUpdate.vue?vue&type=script&lang=js"

import exportComponent from "/home/tek2991/Desktop/Works/Projects/NEW_EPMS/avant-director-production/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__